import { FC, useMemo } from 'react';

import {
  Button,
  Icon,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import clsx from 'clsx';
import { Building, Town } from 'src/api/types';
import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';
import { useTruncated } from 'src/hooks/useTruncated';
import { toAddress } from 'src/utils/toAddress';

import classes from './OfficeSidesheetButton.module.scss';

export interface OfficeSideSheetButtonProps {
  onClick: () => void;
  town: Town | undefined;
  building: Building | undefined;
  disabled: boolean;
  small?: boolean;
}

export const OfficeSideSheetButton: FC<OfficeSideSheetButtonProps> = ({
  onClick,
  disabled,
  town,
  building,
  small,
}) => {
  const { setElement, truncated } = useTruncated();

  const label = useMemo((): string => {
    return toAddress({
      town: town?.townName,
      building: building?.address,
      short: true,
    });
  }, [building?.address, town?.townName]);

  return (
    <TooltipWrapper disableHover={!truncated && !small} title={label}>
      <Button
        fullWidth
        onClick={onClick}
        disabled={disabled}
        variant='outlined'
        className={clsx(classes.container, small && classes.small)}
        data-testid='selectOffice'
        endIcon={<Icon iconName={Icons.Pin} />}
      >
        {!small && (
          <Typography variant='subtitle3' ellipsis ref={setElement}>
            {label}
          </Typography>
        )}
      </Button>
    </TooltipWrapper>
  );
};
